import React, {useMemo, useCallback} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import PropTypes from 'prop-types';

import * as actionCreators from '../../../../../../store/actions';

const propTypes = {
  className: PropTypes.string,
  count: PropTypes.string.isRequired,
  showTitle: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  children: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.instanceOf(Object)]),
  countLink: PropTypes.bool,
};

function ResultsInfoHeader(props) {
  // Props.
  const {
    count, className = 'head-title', showTitle = true, title = '', children = null, countLink = true,
  } = props;

  // Get redux states.
  const mapSearchResults = useSelector(state => state.map.mapSearchResults);

  // Set dispatchers.
  const dispatch = useDispatch();
  const toggleLeftOverlay = useCallback(
    (state, force) => dispatch(actionCreators.toggleLeftOverlay(state, force)),
    [dispatch],
  );
  const setActiveTab = useCallback(tab => dispatch(actionCreators.setActiveTab(tab)), [dispatch]);
  const updateListResults = useCallback(() => dispatch(actionCreators.updateListResults()), [
    dispatch,
  ]);
  const updateMapSearchResults = useCallback(
    data => dispatch(actionCreators.updateMapSearchResults(data)),
    [dispatch],
  );

  const defaultClickHandler = useCallback(
    (e) => {
      e.preventDefault();
      toggleLeftOverlay('showResults', true);
      setActiveTab({showResults: 'Results'}, 2);
      if (!mapSearchResults.searchInited) {
        updateMapSearchResults({
          searchInited: true,
        });
        updateListResults();
      }
    },
    [
      mapSearchResults.searchInited,
      setActiveTab,
      toggleLeftOverlay,
      updateListResults,
      updateMapSearchResults,
    ],
  );

  const mobileInfoHeader = useMemo(
    () => (
      <div className={className}>
        {showTitle && title && <h3>{title}</h3>}
        {count && (
          <span className="count">
            {countLink ? (
              <a href="#count" className="num" onClick={defaultClickHandler}>
                {count}
              </a>
            ) : (
              <span className="num">{count}</span>
            )}
            <span className="label">Properties</span>
          </span>
        )}
        {children}
      </div>
    ),
    [children, className, count, countLink, defaultClickHandler, showTitle, title],
  );

  return mobileInfoHeader;
}
ResultsInfoHeader.propTypes = propTypes;

export default ResultsInfoHeader;
